import { StatefulDiaryT } from "@/types/database/diaries";
import { ExtendedEventViewT } from "@/types/database/events";

export function extractEventById(diary: StatefulDiaryT, eventId: string) {
    return diary?.events_view?.find((m) => m.event_id === eventId) as ExtendedEventViewT;
}
